import * as React from "react";

import { IWithBreakpointsProps, withBreakpoints } from "helpers/withBreakpoints";

// FIXME: Fix this the next time the file is edited.
// eslint-disable-next-line import/no-cycle
import NavigationDesktop from "./NavigationDesktop";
// FIXME: Fix this the next time the file is edited.
// eslint-disable-next-line import/no-cycle
import NavigationMobile from "./NavigationMobile";
import { INavigationProps } from "./interfaces";

interface IProps extends INavigationProps, IWithBreakpointsProps {}

// FIXME: Fix this the next time the file is edited.
// eslint-disable-next-line react/display-name
const NavigationComponent: React.FC<IProps> = React.memo(({ isMobile, ...props }) =>
  isMobile ? <NavigationMobile {...props} /> : <NavigationDesktop {...props} />
);
NavigationComponent.displayName = "NavigationComponent";
export default withBreakpoints(NavigationComponent);
